/*
 * SPDX-FileCopyrightText: 2023 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
class Animation {
}
Animation.shortTime = 0;
Animation.defaultTime = 150;
Animation.mediumTime = 300;
Animation.slowTime = 500;
Animation.xSlowTime = 1000;

export { Animation as A };

//# sourceMappingURL=animation-4a73b1c3.js.map